var render = function render(){var _vm=this,_c=_vm._self._c;return _c('loading',{attrs:{"loading":_vm.loading,"loaded":!!_vm.data}},[(!!_vm.data)?_c('related-meeting-carousel',{attrs:{"meetings":_vm.data.data.search.result.groups.hits}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }